/**  @jsx jsx */
import BaseBaseLayout from '@bottlebooks/gatsby-theme-event/src/components/Layout/BaseLayout';
import React from 'react';
import { jsx } from 'theme-ui';
import GoogleTranslate from '../../../../components/GoogleTranslate';

export default function BaseLayout({ children, ...rest }) {
  return (
    <React.Fragment>
      <BaseBaseLayout {...rest}>
        <GoogleTranslate />

        {children}
      </BaseBaseLayout>
    </React.Fragment>
  );
}
